import { Flex } from "@chakra-ui/react";
import { Button} from "@sgi/gravity/Button";
import { Input } from "@sgi/gravity/Input";
import { Typography } from "@sgi/gravity/Typography";
import Title from "../Common/Title";
import { ChangeEvent, KeyboardEvent, useCallback, useState, useEffect } from "react";
import { useEnterEmailProxy } from "../Custom Hooks/useEnterEmailProxy";
import {useConfig} from "../Custom Hooks/useConfig";

export default function EnterEmail() {
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState("");
  const [subText, setSubText] = useState("");
  const { emailError, continueAction } = useEnterEmailProxy({ email });
  const { pageLevelError } = useEnterEmailProxy({ email });
  const [customEmailError, setCustomEmailError] = useState('');
  const config = useConfig();

  const onEmailChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value), []);
  const onEmailKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") continueAction.act();
  }, [continueAction]);

  useEffect(() => {
    // Get the query parameters from the location object
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);

    // Access a specific query parameter by its name
    const param = queryParams.get("claimsexchange");
    if (param === "ForgotPasswordExchange") {
      setTitle("Forgot Password?");
      setSubText("Enter your username or email to continue");
    } else if (param === null) {
      setTitle("Reset MFA");
      setSubText("To reset your Multi-Factor Authentication method, we will need to verify your email first. Please enter your registered email.")
    }
  }, []);

  useEffect(() => {
    if (emailError) {
      setCustomEmailError("Your email doesn't meet our requirement. Please enter a valid email address.")
    }
  }, [emailError]);

  useEffect(() => {
    if (pageLevelError.includes("ResetLegacyUser")) {
      window.location.assign(config.SGI_RESET_PASSWORD_URL);
    }
    else if (pageLevelError.includes("User does not exist")) {
      setCustomEmailError("User cannot be found!!");
    }
  }, [pageLevelError, config]);
    

  const handleCancelClick = () => {
    window.location.assign(config.MYSGI_URL);
  };

  return (
    <Flex direction="column"  maxW={544} padding={38} mx="auto" data-testid="enter-email-page-test">
      <Title text={title} />
      <Typography variant="body" mb={8}>
        {subText}
      </Typography>
      <Input
        autoFocus
        my={1}
        label="Your username or email"
        name="Email"
        id="email-field"
        type="email"
        onChange={onEmailChange}
        onKeyDown={onEmailKeyDown}
        placeholder="email@example.com"
        pattern="^[a-zA-Z0-9!#$%&'+^_`\{\}~\-]+(?:\.[a-zA-Z0-9!#$%&'+^_`\{\}~\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$"
        maxLength={73}
        error={customEmailError}
        data-testid="email-input"
        spellCheck={false}
        isRequired={true}
        value={email}
        autoComplete="username"
      />
      <Button
        my={1}
        isFullWidth
        data-testid="continue-button-test"
        isDisabled={continueAction.disabled}
        onClick={continueAction.act}
      >
        Continue
      </Button>
      <Button
        my={1}
        isFullWidth
        data-testid="cancel-button-test"
        onClick={handleCancelClick}
        variant="ghost"
      >
        Cancel
      </Button>
    </Flex>
  );
}